import React from 'react';
import cn from 'classnames';
import findIndex from 'lodash/findIndex';

import RsSlidable from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidable';
import Button from '@Components/Button';

import './StepsList.theme.scss';

const StepsList = ({ steps, activeStep, setActiveStep, resized, onActiveStepChange }) => {
  const activeStepIndex = findIndex(steps, { step: activeStep } );

  return (
    <RsSlidable
      className="project-route-conditions-steps-list flex-1"
      contentClassName="project-route-conditions-steps-list__list"
      itemClassName={({ step }) => cn('project-route-conditions-steps-list__step', { 'current': step === activeStep })}
      items={steps}
      renderItem={({ step }) =>
        <Button
          buttonConfig={{
            label: `Step ${step}`,
            type: 'link',
            size: 'xs',
            e2eName: 'rt-conditions-step',
          }}
          onClick={() => {
            onActiveStepChange(step);
            setActiveStep(step);
          }}
        />
      }
      visibleItemIndex={activeStepIndex}
      resized={resized}
    />
  );
}

export default StepsList;
